import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import "LIBRARY/Components/User/UserIssuedResources/userIssuedResorces.css";
import LibraryApiCall from 'LibraryApiCall';
import { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { toast } from 'react-toastify';

class StudentIssuedResources extends Component {

    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            pageIndex: 1,
            limit: 10,
            accessDataList: false,
            successModal: false,

            //VARIABLE TO GET ISSUED RESOURCE DATA LIST
            issuedResourceLoading: false,
            issuedResourceData: {},
            totalIssuedResourceItem: 0,
            selectedResourcesDetails: {},
            sortedIdArray: [],

            //VARIABLES TO GET VALUE FOR PRINT RESOURCES DATA
            resourceCertificateTemplate: '',
            resourceCertificateDataHTML: '',
            resourcesCertificateDesign: {},
            fetchingCertificateDetails: false,
            selectedCertificateUniqueId: "",
            defaultNoReceiptDesign: '',

            showPrintReceiptModal: false,

            activeTab: '',

            linkedInstituteArray: {},
            linkedIidArray: []
        }
    }

    componentDidMount() {
        // if (this.props.iidArray?.iidArray?.length > 0) {
        //     this.GetAllMyIssuedResourceList();
        // } else {
        //     setTimeout(() => {
        //         if (this.props.iidArray?.iidArray?.length > 0) {
        //             this.GetAllMyIssuedResourceList();
        //         }
        //     }, 1000); // Delay by 1 second
        // }
        this.GetAssignedInstituteList();
    }

      //API CALL METHOD TO GET Institute
    GetAssignedInstituteList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetLinkedInstituteStatus',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                let linkedInstituteData = apiResult.linkedInstituteData;
                let linkedIidArrayValue = apiResult.linkedIidArray;

                this.setState({
                    linkedInstituteArray: linkedInstituteData,
                    linkedIidArray: linkedIidArrayValue
                });

                this.GetAllMyIssuedResourceList()
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    }


    // componentDidUpdate(prevProps) {
    //     // Compare with previous props to avoid unnecessary calls
    //     if (
    //         (!prevProps.iidArray?.iidArray || prevProps.iidArray.iidArray.length === 0) &&
    //         this.props.iidArray?.iidArray &&
    //         this.props.iidArray.iidArray.length > 0
    //     ) {
    //         this.GetAllMyIssuedResourceList();
    //     }
    // }

    //API CALL METHOD TO LIST OF DONOR LIST REPORT
    GetAllMyIssuedResourceList = async () => {
        this.setState({
            issuedResourceLoading: true
        });

        let requestData = {
            'iid': config.institute_id,
            'pageIndex': this.state.pageIndex,
            'limitPerPage': this.state.limit,
            'userId': config.studentId,
            'role': "student",
            'iidArray': this.props.iidArray.iidArray
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetAllMyIssuedResourceList',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetAllMyIssuedResourceList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            issuedResourceData: apiResult.data,
                            totalIssuedResourceItem: apiResult.totalRecords,
                            sortedIdArray: apiResult.sortedIdArray,
                            issuedResourceLoading: false
                        });
                    } else {
                        this.setState({
                            issuedResourceData: {},
                            totalIssuedResourceItem: 0,
                            sortedIdArray: [],
                            issuedResourceLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        issuedResourceData: {},
                        issuedResourceLoading: false
                    });
                }
            }
        }
    }

    // API CALL TO GET NO DUE LIBRARY RECEIPT
    apiCallToGetLibraryReceipt = async () => {
        this.setState({
            fetchingCertificateDetails: true,
        });

        let requestData = {
            "iid": config.institute_id,
            "searchType": this.state.activeTab
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryReceipt',
            requestData,
            "/api/library/libraryReceiptDesign.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetLibraryReceipt();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let defaultCertificate = '';
                let defaultCertificateData = '';

                Object.keys(apiResult).map((uniqueKey, index) => {
                    let unique_id = uniqueKey;
                    defaultCertificate = apiResult[uniqueKey]['isDefault'];

                    if (defaultCertificate == 'yes') {
                        this.setState({ defaultNoReceiptDesign: false, selectedCertificateUniqueId: unique_id })
                    } else {
                        this.setState({ defaultNoReceiptDesign: true })
                    }
                    defaultCertificateData = apiResult[this.state.selectedCertificateUniqueId];

                });
                this.setState({
                    resourcesCertificateDesign: defaultCertificateData,
                    fetchingCertificateDetails: false,
                }, () => {
                    this.replaceDesignParameters();
                });

            } else {
                this.setState({
                    fetchingCertificateDetails: false,
                });

                toast.error('Something went wrong while getting student list. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // API CALL TO Library Print History
    apiCallToAddLibraryPrintHistory = async () => {
        if (this.state.selectedCertificateUniqueId) {
            let requestData = {
                "iid": config.institute_id,
                "receipt_id": this.state.selectedCertificateUniqueId,
                "printedBy": config.faculty_id,
                "issueReturnUId": this.state.selectedResourcesDetails?.issue_return_unique_id,
                "printedByRole": "faculty",
                "source": "web",
                "type": this.state.activeTab
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'addLibraryPrintHistory',
                requestData,
                "/api/library/libraryReceiptDesign.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToAddLibraryPrintHistory();
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                }
            }
        } else if (this.state.defaultNoReceiptDesign == true) {
            toast.warn("No default design for no due certificate.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            toast.error("No Receipt design for no due certificate.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    // replace design parameters
    replaceDesignParameters = () => {
        let dataOfSelectedResource = this.state.selectedResourcesDetails;


        this.setState({
            resourceCertificateDataHTML: '',
            resourceCertificateTemplate: '',
        })

        let parametersArray = [];
        let resourceCertificateTemplate = this.state.resourceCertificateTemplate;

        let receiptDesignParameters = {
            "Resource_Title": dataOfSelectedResource.title ?? "",
            "Resource_Author": dataOfSelectedResource.author ?? "",
            "Resource_Location": dataOfSelectedResource.location ?? "",
            "Accession_Details": (dataOfSelectedResource.accession_series ?? "") + "-" + (dataOfSelectedResource.accessionnumber ?? ""),
            "Issued_By": dataOfSelectedResource.issued_by ?? "",
            "Issued_Date": dataOfSelectedResource.issued_date ?? "",
            "Role": dataOfSelectedResource.user_role ?? "",
            "ERP_Id": dataOfSelectedResource.user_erp_id ?? "",
            "Issued_To": dataOfSelectedResource.user_name ?? "",
            "Issued_Policy_Name": dataOfSelectedResource.policyName ?? "",
            "Returned_By": dataOfSelectedResource.returned_by ?? "",
            "Return_Date": dataOfSelectedResource.return_date ?? "",
            "Returned_To": dataOfSelectedResource.returned_to ?? "",
            "Applicable_Fine": dataOfSelectedResource.fine_amount ?? "",
            "Collected_Fine": dataOfSelectedResource.collected_fine ?? "",
            "Transaction_Id": dataOfSelectedResource.transaction_id ?? "",
            "Renewed_By": dataOfSelectedResource.renewed_by ?? "",
            "Renewed_To": dataOfSelectedResource.renewed_to ?? "",
            "Student_Prn_University_No": dataOfSelectedResource.studentPrnUniversityNo ?? "",
            "Student_Grn_No": dataOfSelectedResource.studentGrnNo ?? "",
            "Student_Seat_No": dataOfSelectedResource.studentSeatNo ?? "",
            "Student_Roll_No": dataOfSelectedResource.studentRollNo ?? "",
            "Student_First_Name": dataOfSelectedResource.studentFirstName ?? "",
            "Student_Middle_Name": dataOfSelectedResource.studentMiddleName ?? "",
            "Student_Last_Name": dataOfSelectedResource.studentLastName ?? "",
            "Employee_Id": dataOfSelectedResource.employeeId ?? "",
            "Employee_First_Name": dataOfSelectedResource.employeeFirstName ?? "",
            "Employee_Middle_Name": dataOfSelectedResource.employeeMiddleName ?? "",
            "Employee_Last_Name": dataOfSelectedResource.employeeLastName ?? "",
            "Fine_Collected_Date": dataOfSelectedResource.fineCollectedDate ?? "",
        };
        parametersArray.push(receiptDesignParameters);

        let value = this.state.resourcesCertificateDesign;
        resourceCertificateTemplate = value?.receipt_design || "";
        let certificateHTML = resourceCertificateTemplate

        parametersArray.forEach((parameters, index) => {
            for (let fieldName in parameters) {
                if (certificateHTML.includes("{" + fieldName + "}")) {
                    if (fieldName == "Role") {
                        //if present replace it with it's value
                        //code to replace filed 
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "ERP_Id") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "User_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Resource_Title") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Resource_Author") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Resource_Location") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Accession_Details") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Issued_By") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Issued_Date") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Issued_To") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Issued_Policy_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Returned_By") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Return_Date") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Returned_To") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Applicable_Fine") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Collected_Fine") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Transaction_Id") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Renewed_By") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Renewed_To") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Prn_University_No") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Grn_No") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Seat_No") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Roll_No") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_First_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Middle_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Last_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Employee_Id") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Employee_First_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Employee_Middle_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Employee_Last_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Fine_Collected_Date") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                }
            }
        });

        this.setState({
            resourceCertificateDataHTML: certificateHTML,
            resourceCertificateTemplate
        });

    }


    // METHOD TO SELECT EVENT TYPE
    selectPeriodicalType = (type) => {
        if (this.state.activeTab != type) {
            this.setState({
                activeTab: type,
            }, () => {
                this.apiCallToGetLibraryReceipt();
            })
        }
    }

    returnPrintReceipt = () => {
        const { activeTab } = this.state;

        return (
            <div id="addPeriodicalSideMenu" style={{ display: this.state.showPrintReceiptModal ? 'flex' : 'none' }}>
                <div id="addPeriodicalsDataContainer">
                    <div className="row pt-4 pb-3 pl-2">
                        <h5 className="col-11">Print Receipt</h5>
                        <FontAwesomeIcon icon={['fas', 'times']} className='ml-3' size="lg" color="#000" onClick={() => this.setState({ showPrintReceiptModal: false })} style={{ cursor: "pointer" }} />
                    </div>
                    <hr />
                    <div >
                        <div className="issuedResourceHeads">
                            {this.state.selectedResourcesDetails.status === 'issued' ? (
                                (this.state.selectedResourcesDetails.renewal_date && this.state.selectedResourcesDetails.renewal_date !== "0000-00-00") ?
                                    (
                                        <>
                                            <p className={activeTab === 'issue' ? 'issuedResourceActiveTab issuedResourceSettingTab' : 'issuedResourceSettingTab'} onClick={() => this.selectPeriodicalType('issue')}>Issue Receipt</p>
                                            <p className={activeTab === 'renew' ? 'issuedResourceActiveTab issuedResourceSettingTab' : 'issuedResourceSettingTab'} onClick={() => this.selectPeriodicalType('renew')}>Renewal Receipt</p>
                                        </>
                                    ) :
                                    (
                                        <p className={activeTab === 'issue' ? 'issuedResourceActiveTab issuedResourceSettingTab' : 'issuedResourceSettingTab'} onClick={() => this.selectPeriodicalType('issue')}> Issue Receipt</p>
                                    )
                            ) : this.state.selectedResourcesDetails.status === 'returned' ? (
                                (this.state.selectedResourcesDetails.renewal_date && this.state.selectedResourcesDetails.renewal_date !== "0000-00-00") ? (
                                    <>
                                        <p className={activeTab === 'issue' ? 'issuedResourceActiveTab issuedResourceSettingTab' : 'issuedResourceSettingTab'} onClick={() => this.selectPeriodicalType('issue')}>Issue Receipt</p>
                                        <p className={activeTab === 'return' ? 'issuedResourceActiveTab issuedResourceSettingTab' : 'issuedResourceSettingTab'} onClick={() => this.selectPeriodicalType('return')}>Return Receipt</p>
                                        <p className={activeTab === 'renew' ? 'issuedResourceActiveTab issuedResourceSettingTab' : 'issuedResourceSettingTab'} onClick={() => this.selectPeriodicalType('renew')}>Renewal Receipt</p>
                                        <p className={activeTab === 'fine' ? 'issuedResourceActiveTab issuedResourceSettingTab' : 'issuedResourceSettingTab'} onClick={() => this.selectPeriodicalType('fine')}> Fine Receipt</p>
                                    </>
                                ) : (
                                    <>
                                        <p className={activeTab === 'issue' ? 'issuedResourceActiveTab issuedResourceSettingTab' : 'issuedResourceSettingTab'} onClick={() => this.selectPeriodicalType('issue')}>Issue Receipt</p>
                                        <p className={activeTab === 'return' ? 'issuedResourceActiveTab issuedResourceSettingTab' : 'issuedResourceSettingTab'} onClick={() => this.selectPeriodicalType('return')}>Return Receipt</p>
                                        <p className={activeTab === 'fine' ? 'issuedResourceActiveTab issuedResourceSettingTab' : 'issuedResourceSettingTab'} onClick={() => this.selectPeriodicalType('fine')}>Fine Receipt</p>
                                    </>
                                )
                            ) : null}
                        </div>

                        <div className="p-4" ref={el => this.printCertificate = el}>
                            {
                                ReactHtmlParser(this.state.resourceCertificateDataHTML)
                            }
                        </div>

                    </div>
                    <div className="modal-footer pt-5">
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.setState({ showPrintReceiptModal: false })}>Cancel</button>
                        <button className="btn btn-primary">
                            <ReactToPrint
                                trigger={() => {
                                    return <p className="outlineButton pl-3">
                                        <FontAwesomeIcon icon={['fas', 'print']} style={{ fontSize: '16px', marginRight: 5 }} onClick={() => {
                                            this.apiCallToAddLibraryPrintHistory()
                                        }} />
                                    </p>;
                                }}
                                content={() => this.printCertificate}
                                onBeforeGetContent={() => {
                                    return new Promise((resolve) => {
                                        if (this.state.resourceCertificateDataHTML) {
                                            resolve();
                                        }
                                    });
                                }}
                            /> Print
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber }, () => {
            this.GetAllMyIssuedResourceList();
        });
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({ pageIndex: 1, limit: event.target.value }, () => {
            this.GetAllMyIssuedResourceList();
        });
    }

    render() {

        return (
            <>
                <RoutingMenu activeScreen="UserIssuedResources" />

                <div className="libraryComponents-container pr-3">
                    <div className="pb-4">
                        <div className="pt-1 pb-2">
                            <h4>My Issued Resources / Periodicals</h4>
                        </div>
                    </div>

                    {/* list table */}
                    <div className="col-md-12 px-0 div_table">
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                            <div className="print-area" ref={el => this.componentRef = el}>
                                <table className="table table-bordered  vm_libraryReport_table" id="donorListReport">
                                    <thead>
                                        <tr>
                                            {/* <tr className='d-none'>
                                                <th colSpan="11" style={{ textAlign: 'center' }}>
                                                    {config.institute_name}
                                                </th>
                                            </tr>
                                            <tr className='d-none'>
                                                <th colSpan="11" style={{ textAlign: 'center' }}>
                                                    Donor List
                                                </th>
                                            </tr>
                                            <tr className='d-none'>
                                                <th colSpan="11" ></th>
                                            </tr>
                                            <tr style={{ display: 'none' }}>
                                                <th colSpan="11" style={{ textAlign: 'center' }}>
                                                    {
                                                        FilterArray.join(" | ")
                                                    }
                                                </th>
                                            </tr> */}
                                            <tr className='d-none'>
                                                <th colSpan="11"></th>
                                            </tr>
                                            <th>Sr.No</th>
                                            <th>Type</th>
                                            <th>Issued to</th>
                                            <th>Title</th>
                                            <th>Author / Publisher</th>
                                            <th>Accession Details</th>
                                            <th>Role</th>
                                            <th>Issued Policy Name</th>
                                            <th>Issued Date</th>
                                            <th>Due Date</th>
                                            <th>Return Date</th>
                                            <th>Applicable Fine</th>
                                            <th>Collected Fine</th>
                                            <th>Print Receipt</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            this.state.issuedResourceLoading ? <tr>
                                                <td colSpan="11">
                                                    <ButtonLoader />
                                                </td>
                                            </tr> :
                                                Object.keys(this.state.issuedResourceData).length > 0 ?
                                                    (
                                                        this.state.sortedIdArray.map((resourceId, index) => {
                                                            let issuedResourceItem = this.state.issuedResourceData[resourceId];
                                                            if (!issuedResourceItem) return null; // avoid errors if missing

                                                            let TotalFine = 0;
                                                            let issuedDate = new Date(issuedResourceItem.issued_date);

                                                            let formattedIssuedDate = issuedDate.toLocaleDateString('en-GB', {
                                                                day: '2-digit', month: 'short', year: 'numeric'
                                                            });

                                                            let returnDate = new Date(issuedResourceItem.return_date);
                                                            let formattedReturnDate = returnDate.toLocaleDateString('en-GB', {
                                                                day: '2-digit', month: 'short', year: 'numeric'
                                                            });

                                                            if (issuedResourceItem.status == "returned") {
                                                                TotalFine = issuedResourceItem.fine_amount;
                                                            } else {
                                                                TotalFine = issuedResourceItem.late_fine;
                                                            }

                                                            let user_role =
                                                                issuedResourceItem.user_role.charAt(0).toUpperCase() +
                                                                issuedResourceItem.user_role.slice(1);

                                                            return (
                                                                <tr key={index}>
                                                                    <td>
                                                                        {this.state.limit === 'all'
                                                                            ? index + 1
                                                                            : ((this.state.pageIndex - 1) * this.state.limit) + index + 1}
                                                                    </td>

                                                                    {/* type */}
                                                                    <td>
                                                                        {issuedResourceItem?.resourcePeriodicalType
                                                                            ? issuedResourceItem.resourcePeriodicalType.charAt(0).toUpperCase() +
                                                                            issuedResourceItem.resourcePeriodicalType.slice(1)
                                                                            : ""}
                                                                    </td>

                                                                    {/* issued to */}
                                                                    <td>{issuedResourceItem?.user_name || ""}</td>

                                                                    {/* title */}
                                                                    <td>{issuedResourceItem?.title || ""}</td>

                                                                    {/* author */}
                                                                    <td>{issuedResourceItem?.author || ""}</td>

                                                                    {/* Accession */}
                                                                    <td>
                                                                        {issuedResourceItem?.accession_series || issuedResourceItem?.accessionnumber
                                                                            ? `${issuedResourceItem.accession_series}-${issuedResourceItem.accessionnumber}`
                                                                            : ""}
                                                                    </td>

                                                                    {/* Role */}
                                                                    <td>{user_role}</td>

                                                                    {/* Policy Name */}
                                                                    <td>
                                                                        <span
                                                                            title={issuedResourceItem?.policyName}
                                                                            style={{
                                                                                whiteSpace: 'nowrap',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                maxWidth: '200px'
                                                                            }}
                                                                        >
                                                                            {issuedResourceItem?.policyName?.length > 20
                                                                                ? issuedResourceItem.policyName.slice(0, 20) + '...'
                                                                                : issuedResourceItem?.policyName}
                                                                        </span>
                                                                    </td>

                                                                    {/* Issued Date */}
                                                                    <td>{formattedIssuedDate}</td>

                                                                    {/* Due Date */}
                                                                    <td>{issuedResourceItem?.dueDate || ""}</td>

                                                                    {/* Return Date */}
                                                                    <td>
                                                                        {issuedResourceItem?.return_date === "0000-00-00"
                                                                            ? "-"
                                                                            : formattedReturnDate}
                                                                    </td>

                                                                    {/* Applicable Fine */}
                                                                    <td>{TotalFine}</td>

                                                                    {/* Collected Fine */}
                                                                    <td>{issuedResourceItem?.collected_fine || 0}</td>

                                                                    {/* Print */}
                                                                    <td style={{ padding: '0.5rem', cursor: "pointer" }}>
                                                                        <FontAwesomeIcon
                                                                            icon={['fa', 'print']}
                                                                            size="lg"
                                                                            title="Click here to print receipt"
                                                                            onClick={() => {
                                                                                let receiptStatus =
                                                                                    issuedResourceItem.status === 'issued'
                                                                                        ? 'issue'
                                                                                        : issuedResourceItem.status === 'returned'
                                                                                            ? 'return'
                                                                                            : issuedResourceItem.status === 'renewed'
                                                                                                ? 'renew'
                                                                                                : 'fine';

                                                                                this.setState(
                                                                                    {
                                                                                        showPrintReceiptModal: true,
                                                                                        selectedResourcesDetails: issuedResourceItem,
                                                                                        activeTab: receiptStatus
                                                                                    },
                                                                                    () => this.apiCallToGetLibraryReceipt()
                                                                                );
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    )
                                                    :
                                                    <tr>
                                                        <td colSpan="11">
                                                            No data found.
                                                        </td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {
                            (Object.keys(this.state.issuedResourceData).length > 0 || Object.keys(this.state.issuedResourceData).length > this.state.limit) &&
                            <div className='row px-0'>
                                <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                            <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                    <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={this.changeShowEntriesControl}>
                                                        <option value={10}>Entries Per Page 10</option>
                                                        <option value={25}>Entries Per Page 25</option>
                                                        <option value={40}>Entries Per Page 40</option>
                                                        <option value={100}>Entries Per Page 100</option>
                                                        <option value={250}>Entries Per Page 250</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                            <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                <Pagination
                                                    activePage={this.state.pageIndex}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.totalIssuedResourceItem}
                                                    pageRangeDisplayed={3}
                                                    onChange={this.updatePaginationCount}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                            <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                Total Records : {this.state.totalIssuedResourceItem || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            this.returnPrintReceipt()
                        }
                    </div>
                </div>
            </>
        )
    }

}
const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray }
    };
};

export default connect(mapStateToProps)(StudentIssuedResources);